/* unplugin-vue-components disabled */import script from "./birthday.vue?vue&type=script&lang=ts&setup=true"
export * from "./birthday.vue?vue&type=script&lang=ts&setup=true"

export default script